// Trims, drops empty entries and collapses repeated addresses (case-insensitive),
// keeping the first occurrence. The backend sends each CC address once anyway, so
// the summary and the payload must not show the same address several times (TUL-4888).
export const uniqueCcEmails = (ccEmails = []) => {
  const seen = new Set();
  return (ccEmails || []).reduce((memo, email) => {
    const trimmed = (email || '').trim();
    const key = trimmed.toLowerCase();
    if (trimmed.length === 0 || seen.has(key)) {
      return memo;
    }
    seen.add(key);
    return [...memo, trimmed];
  }, []);
};

// Browser address autofill fills every field of a section at once. Identical
// unnamed CC inputs all land in the same section, so one autofill pick populated
// them all (TUL-4888). Giving each input its own `section-*` token keeps them apart.
export const ccEmailInputProps = (index) => ({
  name: `ccEmail${index}`,
  autoComplete: `section-ccEmail${index} email`
});
